/**
 * Determine if we're not running in the browser
 **/
export const isServerRendered = typeof document === "undefined"
